
import React from 'react';
import { Button } from '@/components/ui/button';
import { Crown, Info } from 'lucide-react';

interface MarketingPreviewSectionProps {
  onUpgradeClick: () => void;
}

export const MarketingPreviewSection: React.FC<MarketingPreviewSectionProps> = ({
  onUpgradeClick
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-5 rounded-lg bg-muted/50 border border-border">
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 text-gold mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium text-foreground mb-1">Preview mode: high-visibility nights only</p>
          <p className="text-sm text-muted-foreground text-pretty">
            Showing nights rated 5+. Premium adds the Moon Planner, Trip Planner, and exports.
          </p>
        </div>
      </div>
      <Button
        variant="premium"
        onClick={onUpgradeClick}
        size="lg"
        className="shrink-0 w-full sm:w-auto"
      >
        <Crown className="w-4 h-4 mr-2" />
        Get Premium
      </Button>
    </div>
  );
};
